import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-no-content-card',
  templateUrl: './no-content-card.component.html',
  styleUrls: ['./no-content-card.component.css']
})
export class NoContentCardComponent implements OnInit {

  constructor(public router: Router,) { }

  ngOnInit(): void {
  }
  navigateToViewAllVideosList(){
    let playListType = '4';
    localStorage.setItem("selfLearnSelectedVideoType", "Trending" );
    localStorage.setItem("selfLearnSelectedPlayList", playListType);
    this.router.navigateByUrl('selfLearn-V2');
  }

}
